import { ref, watch, computed } from "vue";
const useStatefulProps = {
  stateful: { type: Boolean, default: false },
  modelValue: { type: void 0 }
};
const createStatefulProps = (modelValueType, statefulDefault = false) => {
  return {
    stateful: { type: Boolean, default: statefulDefault },
    modelValue: { type: modelValueType }
  };
};
const useStatefulEmits = ["update:modelValue"];
const useStateful = (props, emit, key = "modelValue", options = {}) => {
  const { defaultValue, eventName } = options;
  const event = eventName || `update:${key.toString()}`;
  const valueState = ref(defaultValue === void 0 ? props[key] : defaultValue);
  let unwatchModelValue;
  const watchModelValue = () => {
    unwatchModelValue = watch(() => props[key], (modelValue) => {
      valueState.value = modelValue;
    });
  };
  watch(() => props.stateful, (stateful) => {
    stateful ? watchModelValue() : unwatchModelValue == null ? void 0 : unwatchModelValue();
  }, { immediate: true });
  const valueComputed = computed({
    get: () => {
      if (props.stateful) {
        return valueState.value;
      }
      return props[key];
    },
    set: (value) => {
      if (props.stateful) {
        valueState.value = value;
      }
      emit(event, value);
    }
  });
  return { valueComputed };
};
export {
  useStatefulProps as a,
  useStateful as b,
  createStatefulProps as c,
  useStatefulEmits as u
};
//# sourceMappingURL=useStateful-50e4a6b9.mjs.map
